import React from 'react';
import { useTranslation } from 'react-i18next';
import { useOrganization } from '../../context/OrganizationContext';
import './OrgSwitcher.css';

/**
 * Organization Switcher Component
 *
 * Dropdown to switch between organizations (when user has multiple)
 */
export default function OrgSwitcher() {
  const { t } = useTranslation('organization');
  const { context, organizations, switchContext, loading } = useOrganization();

  if (loading) {
    return null;
  }

  // Don't show switcher if user has 0 or 1 organization
  if (organizations.length <= 1) {
    return null;
  }

  const handleChange = (e) => {
    const value = e.target.value;
    switchContext('organization', value);
  };

  const currentValue = context.orgId || '';

  return (
    <div className="org-switcher">
      <select
        value={currentValue}
        onChange={handleChange}
        className="org-switcher-select"
        title="Switch workspace"
      >
        {organizations.map(org => (
          <option key={org.id} value={org.id}>
            {org.type === 'personal' ? '👤' : '🏢'} {org.name}
          </option>
        ))}
      </select>

      {context.member && (
        <div className="org-switcher-role">
          <span className="role-badge" data-role={context.member.role}>
            {/* El rol crudo («owner», «member») era lo ÚNICO en inglés de esta barra, y
                las traducciones ya existían en los tres idiomas desde que se hizo la
                pestaña de Roles. El segundo argumento es el respaldo: un rol que algún día
                no esté en el diccionario se pinta crudo, como hasta hoy, en vez de
                enseñarle al usuario la clave `roles.roleNames.loQueSea`. */}
            {t(`roles.roleNames.${context.member.role}`, context.member.role)}
          </span>
        </div>
      )}
    </div>
  );
}
